import { datadogRum } from '@datadog/browser-rum';
import React, { Component, ErrorInfo, ReactNode } from 'react';

import { Button, Text } from '@/design-system/components/ui';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error', { error, errorInfo });
    datadogRum.addError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tw:flex tw:flex-col tw:gap-3 tw:m-6 tw:w-fit tw:p-4 tw:rounded-lg tw:border tw:border-destructive/50 tw:bg-destructive/10 tw:text-destructive">
          <p className="tw:font-semibold tw:text-sm">Oops! Something went wrong</p>
          <Text variant="body-md" as="span">
            We are sorry, but something went wrong. Please try to reload the page or contact us if the problem persists.
          </Text>
          <Button className="tw:w-fit tw:mt-2" onClick={() => this.setState({ hasError: false })} variant="primary">
            Reload
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
